// extracted by mini-css-extract-plugin
export var overlay = "styles-module--overlay--2Ml2K";
export var formWrap = "styles-module--formWrap--32Ry7";